import { render, staticRenderFns } from "./component-province-city.vue?vue&type=template&id=2263adb6&scoped=true&"
import script from "./component-province-city.vue?vue&type=script&lang=js&"
export * from "./component-province-city.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2263adb6",
  null
  
)

export default component.exports